<template>
  <div class="row">
    <div v-for="index in showTextReply" :key="index" class="col-md-12">
      <div class="form-group form-focus select-focus">
        <select
          v-model="formParam.detail_button[index - 1].auto_reply_button_id"
          class="form-control selectTextReply"
          @change="(val) => checkAdd(val, index)"
        >
          <option :value="''">-- Select --</option>
          <option
            :disabled="selectedReplyID.includes(row.id)"
            v-for="(row, idxBtn) in textReplyRows"
            :ref="'text_reply_' + row.id"
            :key="idxBtn"
            :value="row.id"
          >
            {{ row.title }}
          </option>
          <!-- separator visual -->
          <option disabled>────────────</option>

          <!-- opsi untuk membuka offcanvas -->
          <option value="__addNew">
            <span><i class="fa fa-plus"></i>Tambah Text Reply Baru</span>
          </option>
        </select>
        <label class="focus-label">Text Reply {{ index }}</label>
      </div>
    </div>
    <div class="col-md-12 text-center">
      <button
        type="button"
        v-if="showTextReply !== 10"
        class="w-100 btn btn-primary btn-sm"
        @click="showTextReply++"
      >
        <i class="fa fa-plus"></i>
      </button>
  
    </div>
  </div>
</template>

<script>
import OffCanvas from "./offCanvas.vue";
import formTextReply from "./formTextReply.vue";
export default {
  name: "textReply",
  components: {
    OffCanvas,
    formTextReply,
  },

  props: {
    value: {
      type: Object,
      default: () => {},
    }, 
    isShowForm: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    _myTabId() {
      return "tabA_" + Date.now() + "_" + Math.random().toString(36).slice(2);
    },
    selectedReplyID() {
      return this.formParam.detail_button
        .map((item) => item.auto_reply_button_id)
        .filter((item) => item !== "");
    },
    formParam: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  
  beforeDestroy() {
    if (this.channel) this.channel.close();
  },
  watch: {
    isShowForm: {
      handler(val) {
        setTimeout(() => {
          if (val) {
            if (this.selectedReplyID.length > 3) {
              this.showTextReply = this.selectedReplyID.length;
            } else {
              this.showTextReply = 3;
            }
          } else {
            this.showTextReply = 3;
          }
        }, 500);
      },
      immediate: true,
    },
  },
  data() {
    return {
      textReplyRows: [],
      showTextReply: 3,
      showPanel: false,
      defaultDetailTextReply: 10,
      channel: null,
      openedWindowRef: null,
      lastIdxAddAction:null,
      textReplyParams: {
        columnFilters: {
          id: "",
          title: "",
          is_publish: "publish",
        },
        page: 1,
        perPage: 500, // perPage
      },
    };
  },
  mounted() {
    if (this.selectedReplyID.length > 3) {
      this.showTextReply = this.selectedReplyID.length;
    }
    this.loadTextReply();
  },
  methods: {
    checkAdd(el, i) {
      let val = el.target.value;
      if (val == "__addNew") {
        this.formParam.detail_button[i - 1].auto_reply_button_id = "";
        el.target.value = "";
        // this.$refs.offcanvas.open();
        this.channel = this.$util.createChannel("member-type-channel");
        this.channel.on(this.onChannelMessage);
        this.lastIdxAddAction = i
        // window.open(this.$router.resolve('/automation/text-reply/list?action=add').href, "_blank");
        this.openCrudTab();
      }
    },
    openCrudTab() {
      const requester = encodeURIComponent(this._myTabId);
      const url = `/automation/text-reply/list?action=add&requester=${requester}`;
      // buka new tab yang terkontrol
      this.openedWindowRef = window.open(
        this.$router.resolve(url).href,
        "_blank"
      );
      // opsional: fokus / store ref untuk fallback postMessage
    },
    updateData() {
      this.loadTextReply();
      this.$refs.offcanvas.close();
      this.showPanel = false;
    },
    onChannelMessage(msg) {
      // struktur pesan: { action: 'created'|'closed', requester: '<tabId>', data: {...} }
      if (!msg || !msg.requester) return;

      // Hanya tangani pesan yang ditujukan ke kita (msg.target may be 'all' or specific)
      // Jika requester di msg === myTabId -> artinya pesan dari tab yang kita buka
      if (msg.requester === this._myTabId) {
        if (msg.action === 'created') {
          // data: { id, label, ... } 
          // 1) reload list / atau push item optimistically
          this.loadTextReply(); // atau this.memberTypes.push(msg.data)
          // 2) set selected to new id 
          // this.selectedType = msg.data.id;
          if(msg.data.isExit == 1){
            setTimeout(() => {
              this.formParam.detail_button[this.lastIdxAddAction - 1].auto_reply_button_id = msg.data.data.id;
            }, 500);
            this.channel.close();
          }
        } else if (msg.action === 'closed') {
          // optional: fokus kembali ke page atau notif
          // nothing required
        }
      }
    },
    async loadTextReply() {
      this.buttonsLoading = await true;
      this.textReplyParams.page = 0;
      await this.$store
        .dispatch("automation/listTextReply", this.textReplyParams) // sesuai kan dengan method di API
        .then((response) => {
          const { data } = response;
          this.textReplyRows = data.data;
          this.buttonsLoading = false;
        })
        .catch((error) => {
          this.buttonsLoading = false;
          console.log(error);
        });
    },
  },
};
</script>
 


// WEBPACK FOOTER //
// src/components/TextReply/index.vue